<template>
  <div id="header-mobile">
    <TheSiteLogo />
    <TheSearchBar />
    <TheMenu />
  </div>
</template>

<script>
import TheSiteLogo from '@/components/common/TheSiteLogo.vue';
import TheSearchBar from '@/components/common/TheSearchBar.vue';
import TheMenu from '@/components/common/TheMenu.vue';

export default {
  name: 'AppHeaderMobile',

  components: {
    TheSiteLogo,
    TheSearchBar,
    TheMenu,
  },
};
</script>

<style lang="scss" scoped>
  #header-mobile {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 60px;
    background-color: $black;
  }
</style>
